var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("FormSubmitPopup", {
    attrs: {
      title: _vm.title,
      rightMethod: _vm.confirmMerge,
      rightButtonText: "Merge",
      large: ""
    },
    on: {
      popupClose: function($event) {
        return _vm.$emit("input", false)
      }
    },
    scopedSlots: _vm._u([
      {
        key: "input",
        fn: function() {
          return [
            _c(
              "v-layout",
              { attrs: { "justify-space-between": "" } },
              [
                _c(
                  "v-flex",
                  { attrs: { sm6: "" } },
                  [
                    _c(
                      "v-list",
                      { attrs: { subheader: "" } },
                      [
                        _c(
                          "v-list-tile",
                          [
                            _c("v-text-field", {
                              staticClass: "required_field",
                              attrs: {
                                disabled: "",
                                label: "Current product name",
                                value: _vm.productNameDisplay(_vm.product),
                                "prepend-icon": "devices_others"
                              }
                            })
                          ],
                          1
                        )
                      ],
                      1
                    ),
                    _vm._v(" "),
                    _c("br"),
                    _vm._v(" "),
                    _c(
                      "v-layout",
                      { attrs: { warp: "", "justify-space-between": "" } },
                      [
                        _c(
                          "v-flex",
                          { attrs: { sm5: "" } },
                          [
                            _c(
                              "v-list",
                              { attrs: { subheader: "" } },
                              [
                                _c(
                                  "v-list-tile",
                                  [
                                    _c("v-text-field", {
                                      attrs: {
                                        disabled: "",
                                        label: "Price",
                                        type: "number"
                                      },
                                      model: {
                                        value: _vm.product.price,
                                        callback: function($$v) {
                                          _vm.$set(_vm.product, "price", $$v)
                                        },
                                        expression: "product.price"
                                      }
                                    })
                                  ],
                                  1
                                )
                              ],
                              1
                            )
                          ],
                          1
                        ),
                        _vm._v(" "),
                        _c(
                          "v-flex",
                          { attrs: { sm5: "" } },
                          [
                            _c(
                              "v-list",
                              { attrs: { subheader: "" } },
                              [
                                _c(
                                  "v-list-tile",
                                  [
                                    _c("v-select", {
                                      attrs: {
                                        disabled: "",
                                        items: _vm.conditions,
                                        label: "Condition",
                                        "prepend-icon": "thumbs_up_down"
                                      },
                                      model: {
                                        value: _vm.product.condition,
                                        callback: function($$v) {
                                          _vm.$set(
                                            _vm.product,
                                            "condition",
                                            $$v
                                          )
                                        },
                                        expression: "product.condition"
                                      }
                                    })
                                  ],
                                  1
                                )
                              ],
                              1
                            )
                          ],
                          1
                        )
                      ],
                      1
                    ),
                    _vm._v(" "),
                    _c(
                      "v-layout",
                      [
                        _c(
                          "v-flex",
                          { staticClass: "mx-3" },
                          [
                            _c("v-combobox", {
                              attrs: {
                                disabled: "",
                                label: "ASIN",
                                chips: "",
                                multiple: "",
                                "deletable-chips": "",
                                "prepend-icon": "filter_list",
                                clearable: ""
                              },
                              model: {
                                value: _vm.product.asin,
                                callback: function($$v) {
                                  _vm.$set(_vm.product, "asin", $$v)
                                },
                                expression: "product.asin"
                              }
                            })
                          ],
                          1
                        )
                      ],
                      1
                    ),
                    _vm._v(" "),
                    _c(
                      "v-layout",
                      { attrs: { warp: "", "justify-space-between": "" } },
                      [
                        _c(
                          "v-flex",
                          [
                            _c(
                              "v-list",
                              { attrs: { subheader: "" } },
                              [
                                _c(
                                  "v-list-tile",
                                  [
                                    _c(
                                      "v-layout",
                                      {
                                        attrs: {
                                          "justify-space-between": "",
                                          "align-baseline": ""
                                        }
                                      },
                                      [
                                        _c(
                                          "v-flex",
                                          [
                                            _c("v-text-field", {
                                              attrs: {
                                                id: "upc",
                                                label: "UPC",
                                                disabled: "",
                                                "prepend-icon": "bookmarks"
                                              },
                                              model: {
                                                value: _vm.product.upc,
                                                callback: function($$v) {
                                                  _vm.$set(
                                                    _vm.product,
                                                    "upc",
                                                    $$v
                                                  )
                                                },
                                                expression: "product.upc"
                                              }
                                            })
                                          ],
                                          1
                                        )
                                      ],
                                      1
                                    )
                                  ],
                                  1
                                )
                              ],
                              1
                            )
                          ],
                          1
                        )
                      ],
                      1
                    ),
                    _vm._v(" "),
                    _c(
                      "v-layout",
                      [
                        _c(
                          "v-flex",
                          { staticClass: "mx-3" },
                          [
                            _c("v-textarea", {
                              staticClass: "thinBox",
                              attrs: {
                                disabled: "",
                                label: "Note",
                                outline: ""
                              },
                              model: {
                                value: _vm.product.note,
                                callback: function($$v) {
                                  _vm.$set(_vm.product, "note", $$v)
                                },
                                expression: "product.note"
                              }
                            })
                          ],
                          1
                        )
                      ],
                      1
                    )
                  ],
                  1
                ),
                _vm._v(" "),
                _c(
                  "v-flex",
                  { attrs: { sm6: "" } },
                  [
                    _c(
                      "v-list",
                      { attrs: { subheader: "" } },
                      [
                        _c(
                          "v-list-tile",
                          [
                            _c("v-autocomplete", {
                              staticClass: "required_field",
                              attrs: {
                                items: _vm.products,
                                "item-value": "id",
                                "return-object": "",
                                "item-text": _vm.productNameDisplay,
                                label: "Target product",
                                "prepend-icon": "devices_others",
                                rules: [_vm.fieldIsRequired("product")],
                                clearable: ""
                              },
                              model: {
                                value: _vm.targetProduct,
                                callback: function($$v) {
                                  _vm.targetProduct = $$v
                                },
                                expression: "targetProduct"
                              }
                            })
                          ],
                          1
                        )
                      ],
                      1
                    ),
                    _vm._v(" "),
                    _c("br"),
                    _vm._v(" "),
                    _c(
                      "v-layout",
                      { attrs: { warp: "", "justify-space-between": "" } },
                      [
                        _c(
                          "v-flex",
                          { attrs: { sm5: "" } },
                          [
                            _c(
                              "v-list",
                              { attrs: { subheader: "" } },
                              [
                                _c(
                                  "v-list-tile",
                                  [
                                    _c("v-text-field", {
                                      attrs: {
                                        disabled: "",
                                        label: "Price",
                                        "prepend-icon": "attach_money",
                                        type: "number"
                                      },
                                      model: {
                                        value: _vm.targetProduct.price,
                                        callback: function($$v) {
                                          _vm.$set(
                                            _vm.targetProduct,
                                            "price",
                                            $$v
                                          )
                                        },
                                        expression: "targetProduct.price"
                                      }
                                    })
                                  ],
                                  1
                                )
                              ],
                              1
                            )
                          ],
                          1
                        ),
                        _vm._v(" "),
                        _c(
                          "v-flex",
                          { attrs: { sm5: "" } },
                          [
                            _c(
                              "v-list",
                              { attrs: { subheader: "" } },
                              [
                                _c(
                                  "v-list-tile",
                                  [
                                    _c("v-select", {
                                      attrs: {
                                        disabled: "",
                                        items: _vm.conditions,
                                        label: "Condition",
                                        "prepend-icon": "thumbs_up_down",
                                        clearable: ""
                                      },
                                      model: {
                                        value: _vm.targetProduct.condition,
                                        callback: function($$v) {
                                          _vm.$set(
                                            _vm.targetProduct,
                                            "condition",
                                            $$v
                                          )
                                        },
                                        expression: "targetProduct.condition"
                                      }
                                    })
                                  ],
                                  1
                                )
                              ],
                              1
                            )
                          ],
                          1
                        )
                      ],
                      1
                    ),
                    _vm._v(" "),
                    _c(
                      "v-layout",
                      [
                        _c(
                          "v-flex",
                          { staticClass: "mx-3" },
                          [
                            _c("v-combobox", {
                              attrs: {
                                disabled: "",
                                value: _vm.targetAsin,
                                label: "ASIN",
                                chips: "",
                                multiple: "",
                                "deletable-chips": "",
                                "prepend-icon": "filter_list",
                                clearable: ""
                              }
                            })
                          ],
                          1
                        )
                      ],
                      1
                    ),
                    _vm._v(" "),
                    _c(
                      "v-layout",
                      { attrs: { warp: "", "justify-space-between": "" } },
                      [
                        _c(
                          "v-flex",
                          [
                            _c(
                              "v-list",
                              { attrs: { subheader: "" } },
                              [
                                _c(
                                  "v-list-tile",
                                  [
                                    _c(
                                      "v-layout",
                                      {
                                        attrs: {
                                          "justify-space-between": "",
                                          "align-baseline": ""
                                        }
                                      },
                                      [
                                        _c(
                                          "v-flex",
                                          [
                                            _c("v-text-field", {
                                              attrs: {
                                                disabled: "",
                                                label: "UPC",
                                                "prepend-icon": "bookmarks"
                                              },
                                              model: {
                                                value: _vm.targetProduct.upc,
                                                callback: function($$v) {
                                                  _vm.$set(
                                                    _vm.targetProduct,
                                                    "upc",
                                                    $$v
                                                  )
                                                },
                                                expression: "targetProduct.upc"
                                              }
                                            })
                                          ],
                                          1
                                        )
                                      ],
                                      1
                                    )
                                  ],
                                  1
                                )
                              ],
                              1
                            )
                          ],
                          1
                        )
                      ],
                      1
                    ),
                    _vm._v(" "),
                    _c(
                      "v-layout",
                      [
                        _c(
                          "v-flex",
                          { staticClass: "mx-3" },
                          [
                            _c("v-textarea", {
                              staticClass: "thinBox",
                              attrs: {
                                disabled: "",
                                id: "product_note",
                                label: "Note",
                                outline: "",
                                value: _vm.targetNote
                              }
                            })
                          ],
                          1
                        )
                      ],
                      1
                    )
                  ],
                  1
                )
              ],
              1
            ),
            _vm._v(" "),
            _c(
              "v-layout",
              [
                _c(
                  "v-flex",
                  { attrs: { sm12: "", "text-lg-center": "" } },
                  [
                    _c("v-checkbox", {
                      staticClass: "productEditCheckBox",
                      attrs: {
                        name: "confirmMerge",
                        label:
                          "After merging, current product will be delete. Only self confirmed quantity will be added to the target product if selected. All related offers and tasks will be linked to the new product",
                        color: "blue",
                        rules: [
                          function(v) {
                            return v || "Please confirm this info"
                          }
                        ]
                      },
                      model: {
                        value: _vm.isConfirmed,
                        callback: function($$v) {
                          _vm.isConfirmed = $$v
                        },
                        expression: "isConfirmed"
                      }
                    })
                  ],
                  1
                )
              ],
              1
            )
          ]
        },
        proxy: true
      }
    ]),
    model: {
      value: _vm.value,
      callback: function($$v) {
        _vm.value = $$v
      },
      expression: "value"
    }
  })
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-d2132998", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-d2132998","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/ProductsMerge.vue
// module id = null
// module chunks = 